import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import koneLogo from '../assets/kone-logo.png';
import resolveGuruLogo from '../assets/resolveGuru.png';
import releaseData from '../config/release.json';
import useUserPermissions from '../hooks/useUserPermissions';

function Header({ signOut, user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAboutModalOpen, setIsAboutModalOpen] = React.useState(false);
  const {
    canAccessIncidentResolver,
    canAccessSnAnalysis,
    canAccessProdPerformance,
    canAccessRunbooks,
    isLoading,
  } = useUserPermissions();

  // Check active state for each page
  const isIncidentActive = location.pathname.includes("/incident_view") || location.pathname === "/";
  const isSnAnalysisActive = location.pathname.includes('/sn-analysis');
  const isProdPerfActive = location.pathname.includes("/prod-performance");
  const isRunbookActive = location.pathname.includes("/runbook") || location.pathname.includes("/edit-runbook");

  return (
    <>
      <header className="kone-header">
        <div className="kone-header-left">
          <a href="/" className="kone-logo-link">
            <img src={koneLogo} alt="KONE Logo" className="kone-logo-img" />
          </a>
          <img src={resolveGuruLogo} alt="ResolveGuru" className="kone-resolveguru-logo" />
          <div className="kone-header-divider" />
          <nav className="kone-nav">
            {!isLoading && canAccessIncidentResolver() && (
              <button
                id="incidentid"
                onClick={() => navigate("/incident_view")}
                className={`kone-nav-tab ${isIncidentActive ? 'kone-nav-tab-active' : ''}`}
              >
                ServiceNow Resolver
              </button>
            )}
            {!isLoading && canAccessProdPerformance() && (
              <button
                id="prodProductPerformance"
                onClick={() => navigate("/prod-performance")}
                className={`kone-nav-tab ${isProdPerfActive ? 'kone-nav-tab-active' : ''}`}
              >
                Prod Performance
              </button>
            )}
            {!isLoading && canAccessRunbooks() && (
              <button
                id="Runbooks"
                onClick={() => navigate("/runbook_list")}
                className={`kone-nav-tab ${isRunbookActive ? 'kone-nav-tab-active' : ''}`}
              >
                Runbooks
              </button>
            )}
            {!isLoading && canAccessSnAnalysis() && (
              <button
                id="snAnalysis"
                onClick={() => navigate('/sn-analysis')}
                className={`kone-nav-tab ${isSnAnalysisActive ? 'kone-nav-tab-active' : ''}`}
              >
                Service Need Analysis
              </button>
            )}
          </nav>
        </div>

        <div className="kone-header-right">
          {(user?.username || user?.signInDetails?.loginId) && (
            <span className="kone-header-welcome">
              Welcome, {(user?.signInDetails?.loginId || user?.username || '').replace('KONE-AzureAD_', '')}
            </span>
          )}
          <button
            onClick={() => setIsAboutModalOpen(true)}
            className="kone-header-icon-btn"
            title="About"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="8" strokeWidth="3" strokeLinecap="round" />
              <line x1="12" y1="12" x2="12" y2="16" />
            </svg>
          </button>
          <button
            onClick={signOut}
            className="kone-header-action"
          >
            Logout
          </button>
        </div>
      </header>

      {/* About / Release Notes Modal */}
      {isAboutModalOpen && (
        <div className="about-modal-overlay" onClick={() => setIsAboutModalOpen(false)}>
          <div className="about-modal" onClick={(e) => e.stopPropagation()}>
            <div className="about-modal-header">
              <h3>About</h3>
              <button className="about-modal-close-icon" onClick={() => setIsAboutModalOpen(false)}>
                &times;
              </button>
            </div>
            <div className="about-modal-body">
              {releaseData?.map((release) => (
                <div key={release.version} className="about-modal-release">
                  <strong>Version {release.version}</strong>{release.date && <span className="about-modal-date"> — {release.date}</span>}
                  {release.description.split('\n').map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              ))}
            </div>
            {/* <div className="about-modal-footer">
              <button onClick={() => setIsAboutModalOpen(false)} className="kone-btn kone-btn-secondary">Close</button>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
